import { ReferenceNumberValidationResult, createReferenceNumberValidationResult, } from "./reference-number-validation-result";

function getOnlyNumbers(value: string) {
    return value.replace(/[\D]/g, '').trim();
}

function isChecksumValid(candidate: string): { isValid: boolean, isAfter2000: boolean } {

    let workingPart = Number.parseInt(candidate.substring(0, 9));
    const checksum = Number.parseInt(candidate.substring(9));

    // Default to false
    let isAfter2000 = false;
    let isValid = false;

    //  Before 2000 
    if (calculateChecksum(workingPart) === checksum) {
        isAfter2000 = false;
        isValid = true;
    }
    else {
        workingPart += 2_000_000_000;

        // After 2000 
        if (calculateChecksum(workingPart) === checksum) {
            isAfter2000 = true;
            isValid = true;
        }
    }

    return { isValid, isAfter2000 };

    function calculateChecksum(number: number) {
        return 97 - (number % 97);
    }
}

export function isValidPersonNumber(referenceNumber: string, isBelgian: boolean): ReferenceNumberValidationResult {
    const isBoolean = typeof isBelgian === 'boolean';
    if (!isBoolean)
        throw new Error("textValidators.IsValidReferenceNumber: the isBelgian parameter is required");

    // null or undefined is passed
    if (!referenceNumber)
        return createReferenceNumberValidationResult(false, ["Empty"]);

    const trimmed = referenceNumber.trim();
    if (trimmed.length === 0)
        return createReferenceNumberValidationResult(false, ["Empty"]);

    // Foreign reference numbers are considered valid as soon as they contain at least 1 non-whitespace character
    if (!isBelgian)
        return createReferenceNumberValidationResult(true);

    const cleaned = getOnlyNumbers(referenceNumber);
    if (cleaned.length !== 11)
        return createReferenceNumberValidationResult(false, ["Length"]);

    const checksumValidation = isChecksumValid(cleaned);
    if (!checksumValidation.isValid)
        return createReferenceNumberValidationResult(false, ["Checksum"]);

    return createReferenceNumberValidationResult(true);
}

